import styled from 'styled-components'

interface Style {
  columnNumber: number
  width?: any
}

export const TableContainer = styled.div`
  display: grid;
  width: ${(props: Style) => {
    if (props.width) return props.width
    return 'auto'
  }};
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  grid-template-columns: ${(props: Style) => {
    let columns = ''
    for (let i = 0; i < props.columnNumber; i++) {
      columns = columns.concat(' ', 'auto')
    }
    return columns
  }};

  .border-top-left {
    border-top-left-radius: 10px;
  }

  .border-top-right {
    border-top-right-radius: 10px;
  }

  .border-bottom-left {
    border-bottom-left-radius: 10px;
  }

  .border-bottom-right {
    border-bottom-right-radius: 10px;

    span {
      margin: 0px 10px;
    }
  }

  .grid-header {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 12px;

    cursor: pointer;

    border: none;

    height: 40px;
    gap: 2px;

    background: #f5f5f5;
    border-bottom: 1px solid #eeeeee;

    color: #757575;
    font-family: 'Inter';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.48px;
    text-transform: uppercase;
  }

  .grid-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 12px;

    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;

    max-width: 180px;
    height: 72px;
    gap: 8px;

    border-bottom: 1px solid #eeeeee;
    margin-right: 16px;

    color: #1c1d22;

    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.28px;
  }

  .grid-item-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    height: 72px;
    gap: 8px;

    border-bottom: 1px solid #eeeeee;

    color: #1c1d22;

    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.28px;

    img {
      width: 26px;
      height: 26px;
    }
  }

  .grid-action {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 72px;
    gap: 16px;

    border-bottom: 1px solid #eeeeee;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .grid-footer {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 40px;
    gap: 2px;
    padding: 20px;

    background: #f5f5f5;
    border-bottom: 1px solid #eeeeee;

    color: #757575;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.48px;
  }

  .table-chevron {
    border-radius: 6px;

    box-shadow: 0px 2px 5px 0px rgba(89, 96, 120, 0.1),
      0px 0px 0px 1px rgba(254, 237, 178, 0.16),
      0px 1px 1px 0px rgba(254, 237, 178, 0.1);

    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(44%) sepia(0%) saturate(1670%)
      hue-rotate(175deg) brightness(102%) contrast(75%);
  }
`
